import { Component, Injectable, Input, Compiler } from '@angular/core';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackLine } from '../../../../../app/models/dataPackLine.model';
import { DataPackValue } from '../../../../../app/models/dataPackValue.model';
import { AlertService } from '../../../../../app/utils/alert.service';
import { ConsumeService } from '../../../../../app/services/consume.service';
import { VoiceConsumeService } from '../../../../../app/services/voice.consume.service';

  import * as _ from "lodash";

/**
 * @version $Id: content.component.ts 63831 2017-09-23 17:42:15Z sandro.c.simas $
 */
@Component({
  selector: 'editQuotaLines',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class EditQuotaLinesComponent {

  @Input() selectedGroup: DataPackGroup;
  @Input() selectedLines: Map<string, DataPackLine>;
  @Input() selectedGroupVoice: DataPackGroup;
  @Input() selectedLinesVoice: Map<string, DataPackLine>;
  @Input() isConsumeVoice: boolean;
  @Input() isEditingOverBalance: boolean;
  @Input() hasOverBalanceMonetaryVoice: boolean;
  @Input() hasHibridService: boolean;

  private saving: boolean = false;
  private quota: DataPackValue = new DataPackValue();
  private limit: DataPackValue = new DataPackValue();
  private overBalance: DataPackValue = new DataPackValue();
  private overBalanceLocals: DataPackValue = new DataPackValue();
  private overBalanceAllCalls: DataPackValue = new DataPackValue();
  private quotaPerLine: string;
  private limitPerLine: string;
  private overBalancePerLine: string;
  private overBalanceLocalsPerLine: string;
  private overBalanceAllCallsPerLine: string;
  private pattern: string = '^\\d+$|^\\d+\\.{1}[0-9]{1}$';
  private limitPattern: string = '\\d+$';
  private static readonly GIGA_MIN_BALANCE: number = 0.1;
  private isIlimitedGroup: boolean = false;

  constructor(private activeModal: NgbActiveModal,
              private voiceConsumeService: VoiceConsumeService,
              private consumeService: ConsumeService,
              private alertService: AlertService) {

  }

  ngOnInit() {
    this.quota.value = '0.0';
    this.limit.value = '0';
    this.limit.value = null;
    this.overBalance.value = null;
    this.overBalanceLocals.value = '0';
    this.overBalanceAllCalls.value = '0';
    this.checkIlimitedGroup();
    if (this.isEditingOverBalance && !this.isIlimitedGroup) {
      //edicao de limite de excedente em lote
      this.overBalancePerLine = this.preventNullDatapackValuePerLine(this.selectedGroup.overBalanceLimit).toString().split(",")[0];
      this.overBalanceLocalsPerLine = this.preventNullDatapackValuePerLine(this.selectedGroup.overBalanceLocalsLimit).toString().split(",")[0];
      this.overBalanceAllCallsPerLine = this.preventNullDatapackValuePerLine(this.selectedGroup.overBalanceAllCallsLimit).toString().split(",")[0];
    } else if (this.isConsumeVoice && !this.isIlimitedGroup) {
      //edicao de limite em lote
      this.limitPerLine = this.preventNullDatapackValuePerLine(this.selectedGroup.limit);
    } else {
      //edicao de cota em lote
      if ( (null != this.selectedGroup.unallocatedQuota) && (null != this.selectedGroup.unallocatedQuota.value) ) {
        this.quotaPerLine = this.selectedGroup.unallocatedQuota.value;
        this.selectedLines.forEach((line: DataPackLine) => {
          if ( (null != line.quota) && ( null != line.quota.value) ) {
            this.quotaPerLine = (parseFloat(this.quotaPerLine) + parseFloat(line.quota.value)).toString();
          }
        });

        this.quotaPerLine = (parseFloat(this.quotaPerLine) / this.selectedLines.size).toFixed(1);
        if (this.quotaPerLine.split(".")[1] === '0') {
          this.quotaPerLine = this.quotaPerLine.split(".")[0];
        }
      } else {
        this.quotaPerLine = '0';
      }
    }
    if(this.isConsumeVoice){
      this.saving = true;
    }else{
      this.saving = false;
    }
  }

  private checkIlimitedGroup() {
    this.isIlimitedGroup = ( (this.isConsumeVoice) && ((null == this.selectedGroup.limit) || ( null == this.selectedGroup.limit.value)) );
  }

  private convertDataPackValueToNumber(dataPackValue: DataPackValue): number {
    dataPackValue = this.preventNullDataPackValue(dataPackValue);
    if (dataPackValue.value.toString().indexOf('.')) {
      dataPackValue.value = dataPackValue.value.toString().replace('.', ',');
    }
    let value = dataPackValue.value;
    if (dataPackValue.value.toString().indexOf(',')) {
      value = dataPackValue.value.toString().split(",")[0];
    }
    return _.toNumber(value);
  }

  public saveLines() {
    this.saving = false;
    if (this.isEditingOverBalance) {
      this.updateSharedOverBalance();
    } else if (this.isConsumeVoice) {
      this.updateSharedLimits();
    } else {
      this.saveLinesData();
    }
    this.alertService.warn('Salvando as alterações, por favor aguarde!')
  }

  private saveLinesData() {
    let payload = {
      action: 'saveLines',
      hasOverBalanceMonetaryVoice: this.hasOverBalanceMonetaryVoice,
      hasHibridService: this.hasHibridService,
      sourceGroup: {
        id: this.selectedGroup.id
     },
      lines: []
    };
    let linesQuota: number = 0;
    let isLinesQuotaInvalid: boolean = false;
    let quota: number = (!_.isNil(this.quota.value) && this.quota.value !== '') ? _.toNumber(this.quota.value) : 0;
    this.selectedLines.forEach((line: DataPackLine) => {
      line.quota.value = this.quota.value;
      payload.lines.push({
        account: line.account,
        lineNumber: line.lineNumber,
        userName: line.userName,
        quota: line.quota,
        futureQuota: line.futureQuota,
        notifyManagerGroup: line.notifyManagerGroup
      });
    });
    this.consumeService.save(payload).subscribe(
      data => {
        this.resultSucess(data);
        this.saving = true;
      },
      err => {
        this.resultError(err);
        this.saving = true;
      }
    );
  }
  public resultSucess(data:any){
    this.alertService.success(data['result']);
    this.saving = false;
    this.activeModal.close();
  }

  public resultError(err:any){
    this.alertService.error(err.result, err);
    this.saving = false;
    this.activeModal.close();
  }


  private commaToDot(event: any) {
    if (event.target.value && event.target.value.indexOf(',')) {
      event.target.value = event.target.value.replace(',', '.');
    }
  }

  private isLineQuotaValueValidData(value: string) {
    let patt = new RegExp(this.pattern);
    return patt.test(value);
  }

  private updateQuotaData(event: any) {
    this.saving=true;
    this.commaToDot(event);
    let patt = new RegExp(this.pattern);
    this.saving = false;
    if (patt.test(event.target.value)) {
      if (null != this.quota.value) {
        if (Number(event.target.value) > (Number(this.quotaPerLine))) {
          this.saving = false;
          this.alertService.error('A soma das cotas atribuídas excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
          return;
        } else {
          this.selectedLines.forEach((line: DataPackLine) => {
            this.saving = false;
            let substraction = ((parseFloat(event.target.value) * 10) - Number(line.quota.value) * 10) / 10;
            if (Number(line.quotaConsumption.value) > Number(event.target.value)) {
              this.alertService.error('O valor da cota da linha ' + line.lineNumber + ' deve ser superior ao valor já consumido. Por favor reveja as configurações.',null);
              this.saving = false;
              return;
            } else if (substraction > (Number(this.selectedGroup.unallocatedQuota.value) / this.selectedLines.size)) {
              this.alertService.error('A soma das cotas atribuídas excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
              return;
            }
          });
          this.saving  = true;
        }

      }
    }
  }

  private close() {
    this.activeModal.dismiss();
  }

  //Voice

  private preventNullLimit(group: DataPackGroup) {
    if (_.isNil(group.availableLimit)) {
      group.availableLimit = new DataPackValue();
      group.availableLimit.value = '0';
      group.availableLimit.dataPackValueType = 'MIN';
    }
  }
  private preventNullDataPackValue(dataPackValue: DataPackValue): DataPackValue {
    if (_.isNil(dataPackValue)) {
      dataPackValue = new DataPackValue();
      dataPackValue.value = '0';
    }
    return dataPackValue;
  }

  private preventNullDatapackValuePerLine(dataPackValue: DataPackValue): string {
    if ( (null != dataPackValue) && ( null != dataPackValue.value) ) {
      return dataPackValue.value;
    }
    return "---";
  }

  private preventNullOverBalance(group: DataPackGroup) {
    if (_.isNil(group.availableOverBalance)) {
      group.availableOverBalance = new DataPackValue();
      group.availableOverBalance.value = '0';
      group.availableOverBalance.dataPackValueType = 'R$';
    }
  }
  private updateSharedLimits() {
    //this.saving = true;
    let payload = {
      action: 'updateSharedLimits',
      hasOverBalanceMonetaryVoice: this.hasOverBalanceMonetaryVoice,
      hasHibridService: this.hasHibridService,
      sourceGroup: {
        id: this.selectedGroup.id,
      },
      lines: []
    };
    if (this.limit.value && this.limit.value.indexOf(',')) {
      this.limit.value = this.limit.value.replace(',', '.');
    }
    this.selectedLines.forEach((line: DataPackLine) => {
      payload.lines.push({
        account: line.account,
        lineNumber: line.lineNumber,
        userName: line.userName,
        limit: this.limit,
        hasCallCtrl: line.hasCallCtrl
      });
    });
    this.voiceConsumeService.updateSharedLimits(payload).subscribe(
      data => {
        this.resultSucess(data);
      },
      err => {
        this.resultError(err);
      }
    );
  }

  private updateSharedOverBalance() {
    //this.saving = true;
    let payload = {
      action: 'updateSharedOverBalance',
      hasOverBalanceMonetaryVoice: this.hasOverBalanceMonetaryVoice,
      hasHibridService: this.hasHibridService,
      sourceGroup: {
        id: this.selectedGroup.id,
      },
      lines: []
    };
    if(this.isOverBalanceMonetaryVoice()){
      if (this.overBalance.value && this.overBalance.value.indexOf(',')) {
        this.overBalance.value = this.overBalance.value.replace(',', '.');
      }
      this.selectedLines.forEach((line: DataPackLine) => {
        payload.lines.push({
          account: line.account,
          lineNumber: line.lineNumber,
          userName: line.userName,
          limit: line.limit,
          overBalanceLimit: this.overBalance,
          hasCallCtrl: line.hasCallCtrl
        });
      });
    }else{
      this.selectedLines.forEach((line: DataPackLine) => {
        line.overBalanceLocalsLimit.value =this.overBalanceLocals.value;
        line.overBalanceAllCallsLimit.value =this.overBalanceAllCalls.value;
        payload.lines.push({
          account: line.account,
          lineNumber: line.lineNumber,
          userName: line.userName,
          limit: line.limit,
          overBalanceLocalsLimit: line.overBalanceLocalsLimit,
          overBalanceAllCallsLimit:  line.overBalanceAllCallsLimit
        });
      });

    }

    this.voiceConsumeService.updateSharedOverBalance(payload).subscribe(
      data => {
        this.resultSucess(data);
      },
      err => {
        this.resultError(err);
      }
    );
  }

  private isLineLimitValueValid(value: string) {
    let patt = new RegExp(this.limitPattern);
    return patt.test(value);
  }

  private updateLimit(event: any) {
    let patt = new RegExp(this.limitPattern);
    if (patt.test(event.target.value)) {
      if (null != this.limit.value) {
        let selectedLinesLimit;
        let eventValue = event.target.value;
        if (eventValue.indexOf(',')) {
          eventValue = eventValue.replace(',', '.');
        }
        let eventValueSnapshot = eventValue;
        let hasLinesWithBiggerConsume:boolean = false;
        this.selectedLines.forEach((line: DataPackLine) => {
          if (parseFloat(this.preventNullDataPackValue(line.consumedLimit).value) > parseFloat(eventValue)) {
            hasLinesWithBiggerConsume = true;
          }
        });
        if(hasLinesWithBiggerConsume) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('O valor do limite deve ser superior ao valor já consumido. Por favor reveja as configurações.',null);
          this.saving = false;
        } else if ((parseFloat(eventValue) > parseFloat(this.selectedGroup.limit.value))) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('A soma dos limites atribuídos excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
          this.saving = false;
        } else {
          event.target.value = eventValueSnapshot;
          this.saving = true;
        }
      }
    }else {
      this.saving = false;
    }
  }

  private updateOverBalance(event: any) {
    let patt = new RegExp(this.limitPattern);
    if (patt.test(event.target.value)) {
      if (null != this.overBalance.value) {
        let selectedLinesOverBalance;
        let eventValue = event.target.value;
        if (eventValue.indexOf(',')) {
          eventValue = eventValue.replace(',', '.');
        }
        let eventValueSnapshot = eventValue;
        let hasLinesWithBiggerConsume:boolean = false;
        this.selectedLines.forEach((line: DataPackLine) => {
          if (parseFloat(this.preventNullDataPackValue(line.consumedOverBalanceLimit).value) > parseFloat(eventValue)) {
            hasLinesWithBiggerConsume = true;
          }
        });
        if(hasLinesWithBiggerConsume) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('O valor do excedente deve ser superior ao valor já consumido. Por favor reveja as configurações.',null);
          this.saving = false;
        } else if ( parseFloat(eventValue) > parseFloat(this.overBalancePerLine) ) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('A soma dos excedentes atribuídos excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
          this.saving = false;
        } else {
          event.target.value = eventValueSnapshot;
          this.saving = true;
        }
      }
    } else {
      this.saving = false;
    }
  }
  private updateOverBalanceLocals(event: any) {
    let patt = new RegExp(this.limitPattern);
    if (patt.test(event.target.value)) {
      if (null != this.overBalanceLocals.value) {

        let eventValue = event.target.value;
        if (eventValue.indexOf(',')) {
          eventValue = eventValue.replace(',', '.');
        }
        let eventValueSnapshot = eventValue;
        let hasLinesWithBiggerConsume:boolean = false;
        this.selectedLines.forEach((line: DataPackLine) => {
          if (parseFloat(this.preventNullDataPackValue(line.consumedOverBalanceLocalsLimit).value) > parseFloat(eventValue)) {
            hasLinesWithBiggerConsume = true;
          }
        });
        if(hasLinesWithBiggerConsume) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('O valor do excedente locais deve ser superior ao valor já consumido. Por favor reveja as configurações.',null);
          this.saving = false;
        } else if ( parseFloat(eventValue) > parseFloat(this.overBalanceLocalsPerLine) ) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('A soma dos excedentes locais atribuídos excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
          this.saving = false;
        } else {
          event.target.value = eventValueSnapshot;
          this.saving = true;
        }
      }
    } else {
      this.saving = false;
    }
  }
  private updateOverBalanceAllCalls(event: any) {
    let patt = new RegExp(this.limitPattern);
    if (patt.test(event.target.value)) {
      if (null != this.overBalanceAllCalls.value) {

        let eventValue = event.target.value;
        if (eventValue.indexOf(',')) {
          eventValue = eventValue.replace(',', '.');
        }
        let eventValueSnapshot = eventValue;
        let hasLinesWithBiggerConsume:boolean = false;
        this.selectedLines.forEach((line: DataPackLine) => {
          if (parseFloat(this.preventNullDataPackValue(line.consumedOverBalanceAllCallsLimit).value) > parseFloat(eventValue)) {
            hasLinesWithBiggerConsume = true;
          }
        });
        if(hasLinesWithBiggerConsume) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('O valor do excedente outras deve ser superior ao valor já consumido. Por favor reveja as configurações.',null);
          this.saving = false;
        } else if ( parseFloat(eventValue) > parseFloat(this.overBalanceAllCallsPerLine) ) {
          event.target.value = eventValueSnapshot;
          this.alertService.error('A soma dos excedentes outras atribuídos excede a franquia disponível para este grupo. Por favor reveja as configurações.',null);
          this.saving = false;
        } else {
          event.target.value = eventValueSnapshot;
          this.saving = true;
        }
      }
    } else {
      this.saving = false;
    }
  }
  public isOverBalanceMonetaryVoice(){
    return this.hasOverBalanceMonetaryVoice;
  }

  public isHibridService(){
    return this.hasHibridService;
  }

}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/editQuotaLines/content.component.ts